var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "simulate-dialog-container",
      attrs: { visible: _vm.visible, title: "模拟生成规则" },
      on: {
        close: _vm.dialogClose,
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "simulateForm",
          attrs: {
            model: _vm.simulateForm,
            rules: _vm.formRules,
            "label-width": "100px"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "编码规则", prop: "rule_name" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.simulateForm.rule_name,
                          callback: function($$v) {
                            _vm.$set(_vm.simulateForm, "rule_name", $$v)
                          },
                          expression: "simulateForm.rule_name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "申请数量", prop: "apply_num" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.simulateForm.apply_num,
                          callback: function($$v) {
                            _vm.$set(_vm.simulateForm, "apply_num", $$v)
                          },
                          expression: "simulateForm.apply_num"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "vo对象", prop: "sources_data_value" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.simulateForm.sources_data_value,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.simulateForm,
                              "sources_data_value",
                              $$v
                            )
                          },
                          expression: "simulateForm.sources_data_value"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { staticClass: "simulate-res", attrs: { span: 20 } },
                [
                  _c("span", [
                    _vm._v("编码开始：" + _vm._s(_vm.simulateRes.code_start))
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("编码结束：" + _vm._s(_vm.simulateRes.code_end))
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { id: "back-style" }, on: { click: _vm.dialogClose } },
            [_vm._v("取 消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.simulate } },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f838d33", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f838d33","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SettingManage/components/SimulateRuleDialog.vue
// module id = null
// module chunks = 